<script>
  export let name = ""
  export let channel = ""

  import { navigate } from "svelte-routing"
  import api from "../services/api"

  import Header from "../components/Header.svelte"
  import EventCreateProcess from "../components/EventCreateProcess.svelte"
  import ModalPanel from "../components/ModalPanel.svelte"

  let active = false
  let loading = false
  function handleCreate() {
    loading = true
    api
      .request({
        method: "put",
        path: "/events",
        data: {
          eventName: name.trim(),
          channelName: channel,
        },
        credentials: true,
      })
      .then((data) => {
        navigate(`/events/${name}`)
      })
      .catch((err) => {
        console.error(err)
        loading = false
      })
  }
</script>

<Header text="create event" />

<EventCreateProcess {name} {channel} />

<div class="container has-text-centered">
  <button
    class="button is-fullwidth is-primary"
    on:click={() => {
      active = true
    }}
  >
    CREATE EVENT AND START SETUP
  </button>
  <div>This will start all necessary resources and</div>
  <div>create costs.</div>
</div>

<ModalPanel {active}>
  <span slot="header">Are you sure you want<br />to start the setup?</span>
  <span slot="content"
    >This will start all necessary resources and create costs.</span
  >
  <div slot="footer">
    <button
      class="button"
      on:click={() => {
        active = false
      }}>Cancel</button
    >
    <button class="button is-primary" on:click={handleCreate} disabled={loading}
      >OK</button
    >
  </div>
</ModalPanel>

<style>
  .container {
    margin: 4px;
  }
  .container button {
    margin: 60px 0 15px 0;
  }
</style>
